import { BoxProps } from '@chakra-ui/react';

export const iconProps = {
  size: 'xs',
  variant: 'solid',
  colorScheme: 'gray.100',
  boxShadow: 'none',
  fontSize: 'xl',
};

export const carouselCss: BoxProps['css'] = {
  cursor: 'default',
  touchAction: 'pan-y',
  '.items': {
    display: 'grid',
    overflow: 'hidden',
  },
  '.items>*': {
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    zIndex: -1,
    transition: 'opacity .4s ease-in-out',
  },
} as const;

export const carouselActiveCss = (index: number): BoxProps['sx'] => ({
  [`>*:nth-of-type(${index + 1})`]: {
    position: 'relative',
    opacity: 1,
    zIndex: 2,
  },
});
export const slideCarouselCss: BoxProps['css'] = {
  cursor: 'default',
  touchAction: 'pan-y',
  '.items': {
    display: 'flex',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
  '.items::-webkit-scrollbar': {
    display: 'none',
  },
  '.items>*': {
    flex: '0 0 auto',
  },
} as const;
